import { all, call, put, select, takeLatest } from "redux-saga/effects";
import {
  getListNotificationFailed,
  getListNotificationStart,
  getListNotificationSuccess,
} from "../redux/getListNoti";
import { getListNotificationAPI } from "core/http/service/notification";
import { controlInfinitiveScrollSelector } from "components/common/ListInfinitiveScrolling/redux/selector";

function* getListNotificationWork(action) {
  const { offset, limit } = yield select(
    controlInfinitiveScrollSelector("notification")
  );

  const payload = action.payload;
  try {
    const res = yield call(getListNotificationAPI, {
      offset,
      limit,
      ...payload,
    });
    yield put({
      type: getListNotificationSuccess.type,
      payload: res,
    });
  } catch (error: any) {
    yield put({
      type: getListNotificationFailed.type,
    });
  }
}

function* watchGetListNotification() {
  yield takeLatest(getListNotificationStart.type, getListNotificationWork);
}
export default function* getListNotificationSaga() {
  yield all([watchGetListNotification()]);
}
